const ENABLED_VALUES = new Set(['1', 'true', 'yes', 'on']);
export function parseFeatureFlag(value) {
    return (typeof value === 'string' &&
        ENABLED_VALUES.has(value.trim().toLowerCase()));
}
export function resolvePublicFeatureFlags(environment) {
    return Object.freeze({
        obsidianApiKeys: parseFeatureFlag(environment.VITE_FEATURE_OBSIDIAN_API_KEYS),
        aiAssistant: parseFeatureFlag(environment.VITE_FEATURE_AI_ASSISTANT),
        voiceInput: parseFeatureFlag(environment.VITE_FEATURE_VOICE_INPUT),
    });
}
//# sourceMappingURL=feature-flags.js.map